import type { RequestOptions } from "../common/server";
import type { DeepSearchDataJs, SearchEnabledJs } from "@/generated/models";
import { server } from "./server";

export interface DeepSearchParams {
  searchQuery: string;
  limit?: number;
}

export async function deepSearch(params: DeepSearchParams, { signal }: RequestOptions = {}) {
  const searchParams = new URLSearchParams({
    searchQuery: params.searchQuery,
  });

  if (params.limit !== undefined) {
    searchParams.append("limit", params.limit.toString());
  }

  const response = await server.get("search/deepSearch", { searchParams, signal });
  return await response.json() as DeepSearchDataJs;
}

export async function deepSearchEnabled({ signal }: RequestOptions = {}) {
  const response = await server.get("search/enabledForUser", { signal });
  return await response.json() as SearchEnabledJs;
}
